import React from 'react';
import PropTypes from 'prop-types';
import {Link as RouteLink} from 'react-router-dom';

import {Flex, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Breadcrumbs
 * @param {Object} props
 * @param {Function} props.onClick
 */
const Breadcrumbs = ({
  breadcrumbs,
  ...props
}) => {
  const styles = useMultiStyleConfig('Breadcrumbs', {});

  return (
    <Flex {...styles.breadcrumbs}>
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.id || index}>
          {breadcrumb.href ? (
            <Text
              as={RouteLink}
              to={breadcrumb.href}
              {...styles.breadcrumbLink}
            >
              {breadcrumb.label}
            </Text>
          ) : (
            <Text {...styles.breadcrumbText}>
              {breadcrumb.label}
            </Text>
          )}
          {index < breadcrumbs.length - 1 && (
            <Text {...styles.breadcrumbSeparator}>/</Text>
          )}
        </React.Fragment>
      ))}
    </Flex>
  );
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
};

export default Breadcrumbs;
